import {
    ButtonLoader,
    Container,
    HowItWorksContainer,
    InnerInviteContainer,
    InviteContainer,
    ProgressBarContainer,
    RewardsCard,
    RewardsContainer,
    RewardsInnerCard,
    RoundedLoader,
    TitlesContainer,
} from "app/pages/digital-suite/home-page/components/Rewards/LoadingModal/LoadingModal.styled";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import config from "./LoadingModalConfig";

const LoadingModal = () => (
    <Container>
        <TitlesContainer>
            <PixelPlaceholderLoader
                width={config.titles.mainTitle.width}
                height={config.titles.mainTitle.height}
            />
            <PixelPlaceholderLoader
                width={config.titles.subtitle.width}
                height={config.titles.subtitle.height}
            />
        </TitlesContainer>

        <InviteContainer>
            <PixelPlaceholderLoader
                width={config.invite.label.width}
                height={config.invite.label.height}
            />
            <InnerInviteContainer>
                <PixelPlaceholderLoader
                    width={config.invite.input.width}
                    height={config.invite.input.height}
                />
                <ButtonLoader
                    width={config.invite.button.width}
                    height={config.invite.button.height}
                />
            </InnerInviteContainer>
        </InviteContainer>

        <RewardsContainer>
            {Array.from({ length: config.rewards.numberOfCards }).map((_, index) => (
                <RewardsCard key={index}>
                    <RewardsInnerCard>
                        {config.rewards.card.innerLoaders.map((loader, loaderIndex) => (
                            <RoundedLoader
                                key={loaderIndex}
                                width={loader.width}
                                height={loader.height}
                            />
                        ))}
                    </RewardsInnerCard>
                    <PixelPlaceholderLoader
                        width={config.rewards.card.footer.width}
                        height={config.rewards.card.footer.height}
                    />
                </RewardsCard>
            ))}
        </RewardsContainer>

        <ProgressBarContainer>
            <RoundedLoader
                width={config.progressBar.label.width}
                height={config.progressBar.label.height}
            />
            <RoundedLoader
                width={config.progressBar.bar.width}
                height={config.progressBar.bar.height}
            />
        </ProgressBarContainer>

        <HowItWorksContainer>
            <RoundedLoader
                width={config.howItWorks.label.width}
                height={config.howItWorks.label.height}
            />
            <RoundedLoader
                width={config.howItWorks.icon.width}
                height={config.howItWorks.icon.height}
            />
        </HowItWorksContainer>
    </Container>
);

export default LoadingModal;
